import React from "react";
import caseAlertsStyle from "./caseAlertsStyle";
import { Box } from "@mui/material";
import { CaseStatus } from "../../../types/BackofficeCase";
import { STATUS_DATA_COMPLETED as STATUS_DATA_COMPLETED_TRAFFIC } from "../../../services/LeadStatus/StatusTraffic";
import { STATUS_DATA_COMPLETED } from "../../../services/LeadStatus/StatusBasicCase";
import { STATUS_DATA_COMPLETED as STATUS_DATA_COMPLETED_DIVORCE } from "../../../services/LeadStatus/StatusDivorce";
import { STATUS_DATA_COMPLETED as STATUS_DATA_COMPLETED_SETTLEMENT } from "../../../services/LeadStatus/StatusSettlement";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { BackofficeUser, Roles } from "../../../types/BackofficeUser";
import { userHasRole } from "../../../services/backofficeUserService";
import { ProductUnion } from "../../../types/ProductUnion";

const hasMissingPoa = (product: ProductUnion, currentUser: BackofficeUser) => {
  // external users should not be able to view status
  if (userHasRole(currentUser, Roles.external)) {
    return false;
  }

  switch (product.productClassName) {
    case "traffic":
      return (
        product.leadStatus >= STATUS_DATA_COMPLETED_TRAFFIC &&
        product.backofficeCase.status === CaseStatus.open &&
        product.powerOfAttorney === null
      );
    case "divorce":
      return (
        product.leadStatus >= STATUS_DATA_COMPLETED_DIVORCE &&
        product.backofficeCase.status === CaseStatus.open &&
        product.powerOfAttorney === null
      );
    case "settlement":
      return (
        product.leadStatus >= STATUS_DATA_COMPLETED_SETTLEMENT &&
        product.backofficeCase.status === CaseStatus.open &&
        product.powerOfAttorney === null
      );
    case "eventContract":
    case "membershipContract":
    case "otherContract":
    case "providerContract":
    case "dataLeakContract":
    case "purchaseContract":
    case "serviceContract":
    case "subscriptionContract":
    case "travelContract":
    case "vehicleContract":
    case "rentalContract":
    case "trafficAccident":
    case "generalCivilLaw":
    case "civilServiceLaw":
    case "employmentContract":
      return (
        product.leadStatus >= STATUS_DATA_COMPLETED &&
        product.backofficeCase.status === CaseStatus.open &&
        product.powerOfAttorney === null &&
        (product.caseCategory === "defendClaim" || product.caseCategory === "enforceClaim")
      );
    default:
      return false;
  }
};

export default function CaseAlerts({ product }: { product: ProductUnion }) {
  const currentUser = useCurrentUser();

  return (
    <>
      {hasMissingPoa(product, currentUser) && (
        <Box sx={caseAlertsStyle.caseAlert}>Achtung: Keine gültige Vollmacht am Fall vorhanden</Box>
      )}
      {product.preventAllSystemEmails && (
        <Box sx={caseAlertsStyle.caseAlert}>
          Achtung: Automatische E-Mails und Nachrichten an die Mandantschaft sind pausiert!
        </Box>
      )}
      {product.backofficeCase?.preventAllSystemBeaOrFax && (
        <Box sx={caseAlertsStyle.caseAlert}>Achtung: Automatischer beA-/Fax-Versand ist pausiert!</Box>
      )}
      {product.preventAccounting && (
        <Box sx={caseAlertsStyle.caseAlert}>Achtung: Automatische Kontoeinträge/Rechnungen sind pausiert!</Box>
      )}
    </>
  );
}
